import { render, staticRenderFns } from "./lq010a.vue?vue&type=template&id=ffb8ea2a"
import script from "./lq010a.vue?vue&type=script&lang=js"
export * from "./lq010a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports